module.exports = {"150104001":"小召前街","150104002":"兴隆巷","150104003":"长和廊","150104004":"石东路","150104005":"大南街","150104006":"鄂尔多斯路","150104007":"西菜园","150104008":"昭君路","150104100":"小黑河镇","150104400":"裕隆工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150104.json
// module id = 393
// module chunks = 0